import React, { Fragment, useState } from "react"
import { connect } from "react-redux"
import PropTypes from "prop-types"

import {
  RECHARGE_DOCUMENTS_BUTTON_NF,
  RECHARGE_DOCUMENTS_BUTTON_INVOICES
} from "shared/constants/idsElements"
import ModernButton from "shared/components/Button/ModernButton"
import PrePaidDocumentsSkeleton from "components/Skeleton/PrePaidDocumentsSkeleton"
import { showToast } from "components/Toast/index"
import PrePaidDocumentsTable from "./PrePaidDocumentsTable"
import IconNF from "../../../../assets/svg/icon-nf.svg"
import IconInvoice from "../../../../assets/svg/icon-invoice.svg"

import styles from "../../styles.css"

import {
  downloadInvoiceRecharge,
  downloadMultipleInvoiceRecharges
} from "services/state/invoiceRecharges/action"
import { numberToReal } from "services/utils/mask"

const PrePaidDocumentsContainer = ({
  documents = [],
  loading,
  downloadInvoiceRecharge,
  downloadMultipleInvoiceRecharges,
  documentType,
  onDocumentTypeChange,
  customer,
  selectedPhone,
  saveOperation
}) => {
  const [downloadingMultiple, setDownloadingMultiple] = useState(false)

  const handleDownload = (item) => {
    const { invoiceNumber, documentType, amount } = item

    const serviceId = selectedPhone.value
    const historyType = documentType === "FATURA" ? "FATURA" : "NF"
    const valueString = `R$ ${numberToReal(amount)}`
    const description = `InvoiceId: ${invoiceNumber}, Valor: ${valueString}`

    downloadInvoiceRecharge(
      { id: invoiceNumber, type: documentType },
      (response) => {
        const blob = new Blob([response.payload.data], {
          type: "application/pdf"
        })
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement("a")
        a.href = url
        a.download = `${invoiceNumber}.pdf`
        a.click()
        window.URL.revokeObjectURL(url)

        saveOperation(
          customer,
          serviceId,
          `RECHARGE_${historyType}`,
          "DOWNLOAD_DOCUMENT",
          "SUCCESS",
          "",
          description
        )
      },
      (error) => {
        console.error(error)
        showToast({
          message: "Erro ao baixar documento. Tente novamente.",
          type: "error"
        })

        saveOperation(
          customer,
          serviceId,
          `RECHARGE_${historyType}`,
          "DOWNLOAD_DOCUMENT",
          "ERROR",
          "",
          description
        )
      }
    )
  }

  const handleDownloadMultiple = (selectedDocs) => {
    if (!selectedDocs || selectedDocs.length === 0) return

    setDownloadingMultiple(true)

    const serviceId = selectedPhone.value
    const historyType = documentType === "FATURA" ? "FATURA" : "NF"
    const description = `InvoiceIds: ${selectedDocs
      .map((d) => d.invoiceNumber)
      .join(", ")}`
    const payload = { documents: selectedDocs }

    downloadMultipleInvoiceRecharges(
      payload,
      (response) => {
        const blob = new Blob([response.payload.data], {
          type: "application/zip"
        })
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement("a")
        a.href = url
        const fileName =
          historyType === "NF"
            ? `NF-${customer.documentNumber}.zip`
            : `FATURAS-${customer.documentNumber}.zip`
        a.download = fileName
        a.click()
        window.URL.revokeObjectURL(url)
        setDownloadingMultiple(false)

        saveOperation(
          customer,
          serviceId,
          `RECHARGE_${historyType}`,
          "DOWNLOAD_MULTIPLE",
          "SUCCESS",
          "",
          description
        )
      },
      (error) => {
        console.error(error)
        showToast({
          message: "Erro ao baixar os documentos. Tente novamente.",
          type: "error"
        })
        setDownloadingMultiple(false)

        saveOperation(
          customer,
          serviceId,
          `RECHARGE_${historyType}`,
          "DOWNLOAD_MULTIPLE",
          "ERROR",
          "",
          description
        )
      }
    )
  }

  const isFaturaActive = documentType === "FATURA"

  return (
    <Fragment>
      <div className={styles.buttonFilterContainer}>
        <ModernButton
          id={RECHARGE_DOCUMENTS_BUTTON_NF}
          text="Notas fiscais"
          size="small"
          shape="full"
          withBorderRadius
          onClick={() => onDocumentTypeChange("NOTAFISCAL")}
          buttonColor={!isFaturaActive ? "deep_sea_green" : "white"}
          textColor={!isFaturaActive ? "white" : "outer_space"}
          renderIcon={() => <img src={IconNF} />}
        />
        <ModernButton
          id={RECHARGE_DOCUMENTS_BUTTON_INVOICES}
          text="Faturas"
          size="small"
          shape="full"
          withBorderRadius
          onClick={() => onDocumentTypeChange("FATURA")}
          buttonColor={isFaturaActive ? "deep_sea_green" : "white"}
          textColor={isFaturaActive ? "white" : "outer_space"}
          renderIcon={() => <img src={IconInvoice} />}
        />
      </div>

      {loading ? (
        <PrePaidDocumentsSkeleton />
      ) : (
        <PrePaidDocumentsTable
          tableData={documents}
          onDownload={handleDownload}
          onDownloadMultiple={handleDownloadMultiple}
          downloadingMultiple={downloadingMultiple}
          documentType={documentType}
        />
      )}
    </Fragment>
  )
}

PrePaidDocumentsContainer.propTypes = {
  documents: PropTypes.array,
  loading: PropTypes.bool,
  downloadInvoiceRecharge: PropTypes.func,
  downloadMultipleInvoiceRecharges: PropTypes.func,
  documentType: PropTypes.string,
  onDocumentTypeChange: PropTypes.func,
  customer: PropTypes.object,
  selectedPhone: PropTypes.object,
  saveOperation: PropTypes.func
}

const mapStateToProps = ({ customer }) => ({
  customer: customer.data
})

const mapActionsToProps = {
  downloadInvoiceRecharge,
  downloadMultipleInvoiceRecharges
}

export default connect(
  mapStateToProps,
  mapActionsToProps
)(PrePaidDocumentsContainer)



// WEBPACK FOOTER //
// ./src/components/RechargeDocuments/components/PrePaidDocuments/PrePaidDocumentsContainer.js